import React, { useState, useEffect } from 'react';

function ActiveImageDownloads({ onComplete }) {
  const [downloads, setDownloads] = useState([]);

  useEffect(() => {
    fetchDownloads();
    const interval = setInterval(fetchDownloads, 2000);
    return () => clearInterval(interval);
  }, []);

  const fetchDownloads = async () => {
    try {
      const response = await fetch('/api/images/downloads/active', {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        const prevCount = downloads.length;
        setDownloads(data);
        
        // If downloads completed (went from >0 to 0), refresh images
        if (prevCount > 0 && data.length === 0 && onComplete) {
          onComplete();
        }
      }
    } catch (err) {
      console.error('Failed to fetch active downloads:', err);
    }
  };

  const cancelDownload = async (downloadId) => {
    try {
      await fetch(`/api/images/downloads/${downloadId}/cancel`, {
        method: 'POST',
        credentials: 'include'
      });
      fetchDownloads();
    } catch (err) {
      console.error('Failed to cancel download:', err);
    }
  };

  if (downloads.length === 0) return null;

  return (
    <div className="active-downloads">
      <h3>Active Downloads</h3>
      {downloads.map(download => (
        <div key={download.id} className={`download-item ${download.status}`}>
          <div className="download-info">
            <p className="download-title">{download.gallery_name || 'Gallery'}</p>
            <p className="download-url" title={download.url}>{download.url}</p>
          </div>
          
          <div className="download-progress">
            {download.status === 'downloading' && (
              <>
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ 
                      width: `${download.total_files > 0 
                        ? (download.current_file / download.total_files) * 100 
                        : 0}%` 
                    }}
                  />
                </div>
                <span className="progress-text">
                  {download.current_file} / {download.total_files > 0 ? download.total_files : '?'} images
                </span>
                {download.skipped_duplicates > 0 && (
                  <span className="skipped-badge">
                    {download.skipped_duplicates} duplicates skipped
                  </span>
                )}
              </>
            )}
            
            {download.status === 'processing' && (
              <span className="status-text">Processing...</span>
            )}
            
            {download.status === 'completed' && (
              <span className="status-text completed">Completed</span>
            )}
            
            {download.status === 'error' && (
              <span className="status-text error" title={download.error_message}>
                Error: {download.error_message}
              </span>
            )}
          </div>
          
          {download.status === 'downloading' && (
            <button 
              className="btn-cancel"
              onClick={() => cancelDownload(download.id)}
            >
              Cancel
            </button>
          )}
        </div>
      ))}
    </div>
  );
}

export default ActiveImageDownloads;